import styled from 'styled-components'

import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const TitleSection = styled(TitleSectionBase)`
    background: ${(props) => props.theme.color[props.mode === 'Light' ? 'g100' : 'p600']};

    .tradeTab {
        &::after {
            border-bottom-color: ${(props) => props.theme.color[props.mode === 'Light' ? 'g500' : 'g300']};
        }

        .MuiButtonBase-root {
            color: ${(props) => props.theme.color[props.mode === 'Light' ? 'g500' : 'g300']};

            &:hover {
                color: ${(props) => props.theme.color[props.mode === 'Light' ? 'black' : 'white']};
            }

            &.Mui-selected {
                color: ${(props) => props.theme.color[props.mode === 'Light' ? 'p500' : 'white']};

                &:hover {
                    color: ${(props) => props.theme.color[props.mode === 'Light' ? 'p500' : 'white']};
                }
            }
        }

        .indicator {
            background-color: ${(props) => props.theme.color[props.mode === 'Light' ? 'p500' : 'white']};
            border-color: ${(props) => props.theme.color[props.mode === 'Light' ? 'p500' : 'white']};
        }
    }
`

export const Link = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    display: block;
    text-decoration: none;

    @media ${(props) => props.theme.query.mobile} {
        width: 100%;

        & > div {
            display: block;

            button {
                width: 100%;

                span:first-child {
                    margin: 0px;
                }
            }
        }
    }
`

export const RouteElementWrapper = styled(Grid)`
    &:nth-child(even) {
        padding-right: 0;
    }

    @media only screen and (max-width: 900px) {
        && {
            padding-right: 0;
        }
    }
`
